
import { useState } from "react";
import LocationIcon from "assets/Images/icons/LocationIcon.png";
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { CustomRatings } from 'Utills/CustomRatings'
import FavoriteIcon from '@material-ui/icons/Favorite';
import { Link } from "react-router-dom";

//=========================== yacht card slider according to Type ====================
const SliderCard = ({ data, type, user, openLoginModel, linkEnabled, link }) => {
    const [favItem, setFavItem] = useState(null);
    if (type === "listingCard") {
        return (
            <div className="listing-card">
                <div className="fav-itm-fav-icon">
                    {favItem ?
                        <FavoriteIcon
                            style={{
                                color: "var(--color-secondary)",
                                stroke: "#fff",
                                strokeWidth: "2px",
                            }}
                            onClick={() => {
                                user && Object.keys(user).length > 0 ? setFavItem(prev => !prev)
                                    : openLoginModel(true)
                            }
                            } />
                        :
                        <FavoriteBorderIcon
                            className="fav-icon-light"
                            style={{
                                fill: "#fff",
                            }}
                            onClick={() => {
                                user && Object.keys(user).length > 0 ? setFavItem(prev => !prev)
                                    : openLoginModel(true)
                            }
                            }
                        />
                    }
                </div>
                <Wrapper linkEnabled={linkEnabled} link={link}>
                    <div className="fac-card-top"
                        style={{
                            backgroundImage: `url(${data?.img || ''})`
                        }}>
                        {data.otherInfo?.length > 0 &&
                            <div className="listing-card-top-info">
                                {data.otherInfo.map((boxData, ind) => (
                                    <div className="info-boxes" key={ind}>
                                        <div className="info-boxes-icon">
                                            <img src={boxData.icon} alt="" />
                                        </div>
                                        <div className="info-boxes-text">
                                            <p>{boxData.yacht}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                    <div className="fav-card-footer">
                        <div className="item-info">
                            <h4>{data?.title}</h4>
                            <div className="d-flex flex-wrap fav-card-loca pt-2">
                                <img src={LocationIcon} alt="" />
                                <p>{data?.location}</p>
                            </div>
                            <div className="booking-card-ratings p-0">
                                <CustomRatings name="read-only" value={5} readOnly />&nbsp;
                                <span className="font-weight-bold">5 </span><span className="text-muted">/5</span>&nbsp; <span className="text-muted">(23)</span>
                            </div>
                        </div>
                        <div className="fav-item-price">
                            <h5>${data?.price}</h5>
                            <span className="text-muted">/Day</span>
                        </div>
                    </div>
                </Wrapper>
            </div>
        )
    }
    if (type === "favItem") {
        return (
            <div className="listing-card">
                <div className="fav-itm-fav-icon">
                    {favItem ?
                        <FavoriteIcon
                            style={{
                                color: "#1A4D6D",
                                stroke: "#1A4D6D",
                                strokeWidth: "2px",
                            }}
                            onClick={() => {
                                user && Object.keys(user).length > 0 ? setFavItem(prev => !prev)
                                    : openLoginModel(true)
                            }
                            } />
                        :
                        <FavoriteBorderIcon
                            className="fav-icon-light"
                            style={{
                                fill: "#1A4D6D",
                            }}
                            onClick={() => {
                                user && Object.keys(user).length > 0 ? setFavItem(prev => !prev)
                                    : openLoginModel(true)
                            }
                            }
                        />
                    }
                </div>
                <Wrapper linkEnabled={linkEnabled} link={link}>
                    <div className="fac-card-top"
                        style={{
                            backgroundImage: `url(${data?.img || ''})`
                        }}>
                        {data.otherInfo?.length > 0 &&
                            <div className="listing-card-top-info">
                                {data.otherInfo.map((boxData, ind) => (
                                    <div className="info-boxes" key={ind}>
                                        <div className="info-boxes-icon">
                                            <img src={boxData.icon} alt="" />
                                        </div>
                                        <div className="info-boxes-text">
                                            <p>{boxData.yacht}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                    <div className="fav-card-footer">
                        <div className="item-info">
                            <h4>{data?.title}</h4>
                            <div className="d-flex flex-wrap fav-card-loca pt-2">
                                <img src={LocationIcon} alt="" />
                                <p>{data?.location}</p>
                            </div>
                            <div className="booking-card-ratings p-0">
                                <CustomRatings name="read-only" value={5} readOnly />&nbsp;
                                <span className="font-weight-bold">5 </span><span className="text-muted">/5</span>&nbsp; <span className="text-muted">(23)</span>
                            </div>
                        </div>
                        <div className="fav-item-price">
                            <h5>${data?.price}</h5>
                            <span className="text-muted">/Day</span>
                        </div>
                    </div>
                </Wrapper>
            </div>
        )
    }
    return (
        <div className="fav-slider-card">
            <div className="fav-itm-fav-icon">
                {favItem ?
                    <FavoriteIcon
                        style={{
                            color: "var(---color-primary)"
                        }}
                        onClick={() => {
                            user && Object.keys(user).length > 0 ? setFavItem(prev => !prev)
                                : openLoginModel(true)
                        }}
                    />
                    :
                    <FavoriteBorderIcon onClick={() => {
                        user && Object.keys(user).length > 0 ? setFavItem(prev => !prev)
                            : openLoginModel(true)
                    }} />
                }
            </div>
            <Wrapper linkEnabled={linkEnabled} link={link}>
                <div className="fac-card-top">
                    <div className="card-img-wrapp">
                        <img src={data?.img || ''} alt="" />

                    </div>
                </div>
                <div className="fav-card-footer">
                    <div className="item-info">
                        <h4>{data?.title}</h4>
                        <div className="d-flex flex-wrap fav-card-loca pt-2">
                            <img src={LocationIcon} alt="" />
                            <p>{data?.location}</p>
                        </div>
                        <div className="booking-card-ratings p-0">
                            <CustomRatings name="read-only" value={5} readOnly />&nbsp;
                            <span className="font-weight-bold">5 </span><span className="text-muted">/5</span>&nbsp; <span className="text-muted">(23)</span>
                        </div>
                    </div>
                    <div className="fav-item-price">
                        <h5>${data?.price}</h5>
                        <span className="text-muted">/Day</span>
                    </div>
                </div>
            </Wrapper>
        </div>
    )
};

//======================= wrapper will check if this is a clickable or static ======================
const Wrapper = ({ linkEnabled, link, children }) => {
    if (linkEnabled) {
        return (
            <Link to={link}>
                {children}
            </Link>
        )
    }
    else {
        return (
            <div>
                {children}
            </div>
        )
    }
}


export default SliderCard
